
import React from "react";
import { PartCategory } from "@/data/parts";
import { Badge } from "@/components/ui/badge";

interface CategoryCellProps {
  category: PartCategory;
  onClick: (category: PartCategory) => void;
}

const CategoryCell = ({ category, onClick }: CategoryCellProps) => {
  return (
    <Badge 
      variant={category === "k1_series" ? "default" : "secondary"}
      className="cursor-pointer hover:opacity-80 transition-opacity"
      onClick={() => onClick(category)}
    >
      {category === "k1_series" ? "K1" : category === "k2_series" ? "K2" : "TOOLS"}
    </Badge>
  );
};

export default CategoryCell;
